import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import * as AWS from 'aws-sdk/global';

/**
 * Action Types
 */
import {
   ADD_TO_CART,
   ADD_TO_WISHLIST,
   SHOW_ALERT,
   HIDE_ALERT,
   REMOVE_FROM_CART,
   UPDATE_PRODUCT_QUANTITY,
   CHANGE_CURRENCY,
   SET_LANGUAGE,
   FINAL_PAYMENT,
   MOVE_WISHLISTITEM_TO_CART,
   REMOVE_FROM_WISHLIST,
   SET_ACCESS_TOKEN,
   SET_ERROR,
   SET_USER_DATA,
} from './types';
import AppConfig from "../constants/AppConfig";

const poolData = {
    UserPoolId : AppConfig.cognitoConfig.UserPoolId, // Your user pool id here
    ClientId : AppConfig.cognitoConfig.ClientId // Your client id here
};
const userPool = new CognitoUserPool(poolData);

//add product item
export const addProductItem = (data, alertMessage) => (dispatch) => {
   dispatch({
      type: ADD_TO_CART,
      payload: data
   })
}

//show alert box
export const showAlert = (message, type) => ({
   type: SHOW_ALERT,
   payload: { message, type }
})

//hide alert box
export const hideAlert = () => ({
   type: HIDE_ALERT,
})

// add product to wishlist
export const addToWishlist = (data, alertMessage) => (dispatch) => {
   dispatch({
      type: ADD_TO_WISHLIST,
      payload: data
   })
}

//move all wishlist item to cart
export const moveWishlistItemToCart = () => ({
   type: MOVE_WISHLISTITEM_TO_CART
})

//delete wishlist item 
export const deleteItemFromWishlist = (data) => ({
   type: REMOVE_FROM_WISHLIST,
   payload: data
})

//Remove product item
export const removeProductItem = (data) => ({
   type: REMOVE_FROM_CART,
   payload: data
})

//update product quantity
export const updateProductQuantity = (data) => ({
   type: UPDATE_PRODUCT_QUANTITY,
   payload: data
})

// change currency
export const changeCurrency = (currency) => ({
   type: CHANGE_CURRENCY,
   payload: currency
})

// change language
export const setLanguage = (locale) => ({
   type: SET_LANGUAGE,
   payload: locale
})

// setError
export const setError = (message = null) => ({
   type: SET_ERROR,
   payload: { message }
})

//final payment 
export const finalPayment = (history) => (dispatch) => {
   history.push('/final-receipt');
   dispatch({ type: FINAL_PAYMENT });

}

//sign up
export const signUp = (data, history) => (dispatch) => {
   let attributeList = [];

   const dataEmail = {
      Name : 'email',
      Value : data.email
   };
   const dataName = {
      Name : 'name',
      Value : data.firstName
   };
   const dataFamilyName = {
      Name : 'family_name',
      Value : data.lastName
   };

   // var dataPhoneNumber = {
   //    Name : 'phone_number',
   //    Value : '+15555555555'
   // };
   const attributeEmail = new CognitoUserAttribute(dataEmail);
   const attributeName = new CognitoUserAttribute(dataName);
   const attributeFamilyName = new CognitoUserAttribute(dataFamilyName);
   // var attributePhoneNumber = new AmazonCognitoIdentity.CognitoUserAttribute(dataPhoneNumber);

   attributeList.push(attributeEmail);
   attributeList.push(attributeName);
   attributeList.push(attributeFamilyName);
   // attributeList.push(attributePhoneNumber);

   userPool.signUp(data.username, data.password, attributeList, null, function(err, result){
      if (err) {
         console.log('err ', err, err.message, err && err.message);
         if (err && err.message) {
            dispatch(setError(err.message));
         }
         return;
      }
      const user = {
         username: data.username,
      };
      dispatch(setUser(user));
      dispatch(setError());
     /*  const cognitoUser = result.user;
      console.log('user result ', result);
      console.log('user name is ' + cognitoUser.getUsername());  */
      history.push('/verify');
   });
}

//sign in
export const signIn = (data, history) => (dispatch) => {
    const authenticationData = {
        Username : data.username,
        Password : data.password,
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);
    var userData = {
        Username : data.username,
        Pool : userPool
    };
    const cognitoUser = new CognitoUser(userData);
    console.log('cognitoUser: ', cognitoUser);
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
            const accessToken = result.getAccessToken().getJwtToken();
            const payload = (result && result.getIdToken().payload) || {};
            let user = {...payload};
            if(user.address)
               user.address = user.address.formatted;

            //POTENTIAL: Region needs to be set if not already set previously elsewhere.
            AWS.config.region = AppConfig.cognitoConfig.region;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId : AppConfig.cognitoConfig.IdentityPoolId, // your identity pool id here
                Logins : {
                    // Change the key below according to the specific region your user pool is in.
                    [`cognito-idp.${AppConfig.cognitoConfig.region}.amazonaws.com/${AppConfig.cognitoConfig.UserPoolId}`]: result.getIdToken().getJwtToken()
                }
            });

            //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
            AWS.config.credentials.refresh((error) => {
                if (error) {
                    console.error(error);
                    dispatch(setToken());
                    // history.push('/sign-in');
                } else {
                    // Instantiate aws sdk service objects now that the credentials have been updated.
                    // example: var s3 = new AWS.S3();
                    dispatch(setToken(accessToken));
                    dispatch(setUser(user));
                    history.push('/');
                    console.log('Successfully logged!');
                }
            });
        },

        onFailure: function(err) {
            // alert(err.message || JSON.stringify(err));
            if (err && err.message) {
               dispatch(setError(err.message));
               dispatch(setUser());
               dispatch(setToken());
            }
        },

    });
};

// code verify
export const codeVerify = (data, history) => (dispatch) => {
   var userData = {
      Username : data.username,
      Pool : userPool
  };
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.confirmRegistration(data.code, true, function(err, result) {
      if (err && err.message) {
         dispatch(setError(err.message));
         return;
      }
      dispatch(setError());
      history.push('/sign-in');
  }); 
}

// Forgot Password
export const submitForgotPassword = (data, history) => (dispatch) => {
  var userData = {
      Username : data.email,
      Pool : userPool
  };
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.forgotPassword({
      onSuccess: function (result) {
         dispatch(setError());
         history.push('/reset-password');
      },
      onFailure: function(err) {
         if (err && err.message) {
            dispatch(setError(err.message));
         }
      }
  });
}

// Reset Password
export const resetPassword = (data, history) => (dispatch) => {
   var userData = {
       Username : data.username,
       Pool : userPool
   };
   const cognitoUser = new CognitoUser(userData);
   cognitoUser.confirmPassword(data.code, data.newPassword, {
      onFailure: (err) => {
         if (err && err.message) {
            dispatch(setError(err.message));
         }
      },
      onSuccess: (res) =>  {
         dispatch(setError());
         history.push('/sign-in');
      },
  });
}

// set auth token
export const setToken = (accessToken = null) => (dispatch) => {
    if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
    } else {
        localStorage.removeItem('accessToken');
    }

    dispatch({
        type: SET_ACCESS_TOKEN,
        payload: { accessToken }
    })
};

export const getToken = () => (dispatch) => {
    const accessToken = localStorage.getItem('accessToken') || null

    dispatch({
        type: SET_ACCESS_TOKEN,
        payload: { accessToken  }
    })
};

// set user data
export const setUser = (data = null) => (dispatch) => {
    if (data) {
        localStorage.setItem('user', JSON.stringify(data));
    } else {
        localStorage.removeItem('user');
    }

    dispatch({
        type: SET_USER_DATA,
        payload: data
    })
};

// get user data
export const getUser = () => (dispatch) => {
   const user = localStorage.getItem('user');

   dispatch({
      type: SET_USER_DATA,
      payload: (user && JSON.parse(user)) || null
   })
};

// hydrate user
export const hydrateUser = () => (dispatch) => {
    dispatch(getToken())
    dispatch(getUser())
};

// logout
export const logout = (data = null) => (dispatch) => {
   let cognitoUser = userPool.getCurrentUser();
   if(cognitoUser != null)
       cognitoUser.signOut();
   dispatch(setToken())
   dispatch(setUser())
};

// update profile
export const updateProfile = (fields, history ) => (dispatch) => {
   var attributeList = [];
   Object.keys(fields).map((key, index) => {
      var attribute = {
         Name : key,
         Value: fields[key]
      };
      var attribute = new CognitoUserAttribute(attribute);
      attributeList.push(attribute);
   });
   const cognitoUser = userPool.getCurrentUser();
   cognitoUser.getSession((err, session) => {
      if (err) {
         dispatch(logout());
         return;
      }
      cognitoUser.updateAttributes(attributeList, function(err, result) {
         if (err) {
             console.log(err);
             return;
         }
         // Success
         console.log('result : ', result);
         history.push('/account/profile')
      }); 
   });
}

export const updateAttributes = (user) => (dispatch) => {
   let newUser = Object.assign({}, user);
   const cognitoUser = userPool.getCurrentUser();
   cognitoUser.getSession((err, session) => {
      if(err)
         return;
      // Success
      cognitoUser.getUserAttributes(function(err, result) {
            if (err) {
               alert(err);
               return;
            }
            for (let i = 0; i < result.length; i++) {
               var key = result[i].getName();
               var val = result[i].getValue();
               newUser[key] = val;
            }
            console.log('newUser: ', newUser);
            dispatch(setUser(newUser));
      }); 
   });
}



// WEBPACK FOOTER //
// ./src/actions/action.js